<template lang="pug">
div
  .d-flex.justify-content-between.align-items-center.match-detail-function(v-if="![40, 41, 42, 43, 44, 47].includes(sportsType)")
    .function-bar
      .tab-wrapper
        .nav-pills-wrapper
          ul#pills-tab.nav.nav-pills(
            v-if="((source.marketId == 3 && [1,20].includes(sportsType)) || source.marketId != 3)"
            role='tablist'
          )
            template(v-if="[20].includes(sportsType)")
              li.nav-item(v-if="isChild2" v-for="(val, key) in esportTab")
                a.nav-link(
                  :class="{ 'active' : emode == key}"
                  href="javascript:void(0);"
                  @click="goToTab(key)"
                ) {{ $t(val) }}
            template(v-else)
              li.nav-item(v-if="isDetailsTotal || isChild2")
                a.nav-link(
                  :class="{ 'active' : mode == 0 }"
                  href="javascript:void(0);"
                  @click="goToTab(0)"
                ) {{ $t("ui.main") }}
              li.nav-item(v-if="isDetailsFull")
                a.nav-link(
                  :class="{ 'active' : mode == 1 }"
                  href="javascript:void(0);"
                  @click="goToTab(1)"
                ) {{ $t("ui.full_time") }}
              li.nav-item(v-if="isDetailsHalf")
                a.nav-link(
                  :class="{ 'active' : mode == 2 }"
                  href="javascript:void(0);"
                  @click="goToTab(2)"
                ) {{ $t("ui.half_time") }}
              li.nav-item(v-if="isChild1 && checkTabMode3")
                a.nav-link(
                  :class="{ 'active' : mode == 3 }"
                  href="javascript:void(0);"
                  @click="goToTab(3)"
                ) {{ $t("ui.corners") }}
              li.nav-item(v-if="isChild2 && sportsType == 1 && checkTabMode4")
                a.nav-link(
                  :class="{ 'active' : mode == 4 }"
                  href="javascript:void(0);"
                  @click="goToTab(4)"
                ) {{ $t("ui.specials") }}
      .function-item-more(:class="{ 'livetv' : source.marketId == 3 && source.channelId}")
        .btn-favorite(v-if="source.marketId == 3 && source.channelId" @click="popupTV(source)")
          i.fa.fa-tv.pt-1
        .btn-favorite(@click="toggleFavorite()")
          img(src='/images/favorite-active.svg?v=12')
        .btn-sm.btn-collapse.open-all(@click="toggleAll()")
  .d-flex.justify-content-between.align-items-center.match-detail-function(v-else)
    .function-bar
      .tab-wrapper
        .nav-pills-wrapper
          ul#pills-tab.nav.nav-pills(
            role='tablist'
          )
            template(v-if="[40].includes(sportsType)")
              li.nav-item(v-if="isChild2" v-for="(val, key) in sport4dTab")
                a.nav-link(
                  :class="{ 'active' : emode == key}"
                  href="javascript:void(0);"
                  @click="goToTab(key)"
                ) {{ $t(val) }}
            template(v-else)
              li.nav-item(v-if="isChild2" v-for="(val, key) in sportSFVTab")
                a.nav-link(
                  :class="{ 'active' : emode == key }"
                  href="javascript:void(0);"
                  @click="goToTab(key)"
                ) {{ $t(val) }}
      .function-item-more
        .btn-favorite(@click="toggleFavorite()")
          img(src='/images/favorite-active.svg?v=12')
        .btn-sm.btn-collapse.open-all(@click="toggleAll()")
  .tab-content(:id="'content-' + id")
    .tab-pane.accordion-all-leagues.active(:id="'accordian-more-' + id")
      template(v-if="source && details")
        template(v-if="![40, 41, 42, 43, 44, 47].includes(sportsType)")
          template(v-if="[0,1,2].includes(mode)")
            template(v-if="[0,1].includes(mode) && mmoMode && menu3 != 'parlay'")
              template(v-if="(mmoDetails['hdp'] != null && checkOdds(mmoDetails['hdp'], 0) == true) || (mmoDetails['ou'] != null && checkOdds(mmoDetails['ou'], 0) == true)")
                moreHDPOUMMO(:source="source")
            template(v-if="(details['hdp'] != null && checkOdds(details['hdp'], 0) == true) || (details['hdph'] != null && checkOdds(details['hdph'], 0) == true)")
              moreHDP(:source="source" :mode="mode")
            template(v-if="(details['ou'] != null && checkOdds(details['ou'], 0) == true) || (details['ouh'] != null && checkOdds(details['ouh'], 0) == true)")
              moreOU(:source="source" :mode="mode")
            template(v-if="(details['oxt'] != null && checkOdds(details['oxt'], 0) == true) || (details['oxth'] != null && checkOdds(details['oxth'], 0) == true)")
              moreOXT(:source="source" :mode="mode")
            template(v-if="(details['oe'] != null && checkOdds(details['oe'], 1, 'oe') == true) || (details['oeh'] != null && checkOdds(details['oeh'], 1, 'oeh') == true)")
              moreOE(:source="source" :mode="mode")
            template(v-if="(details['ml'] != null && checkOdds(details['ml'], 1, 'ml') == true) || (details['mlh'] != null && checkOdds(details['mlh'], 1, 'mlh') == true)")
              moreML(:source="source" :mode="mode")
            template(v-if="(moreItems['cs'] != null && checkOdds(moreItems['cs'], 0) == true) || (moreItems['csh'] != null && checkOdds(moreItems['csh'], 0) == true)")
              moreCS(:source="source" :mode="mode")
            template(v-if="(moreItems['dc'] != null && checkOdds(moreItems['dc'], 0) == true) || (moreItems['dch'] != null && checkOdds(moreItems['dch'], 0) == true)")
              moreDC(:source="source" :mode="mode")
            template(v-if="(moreItems['tg'] != null && checkOdds(moreItems['tg'], 0) == true) || (moreItems['tgh'] != null && checkOdds(moreItems['tgh'], 0) == true)")
              moreTG(:source="source" :mode="mode")
            template(v-if="(moreItems['fglg'] != null && checkOdds(moreItems['fglg'], 0) == true) || (moreItems['fglgh'] != null && checkOdds(moreItems['fglgh'], 0) == true)")
              moreFGLG(:source="source" :mode="mode")
            template(v-if="(moreItems['tw'] != null && checkOdds(moreItems['tw'], 2) == true) || (moreItems['twh'] != null && checkOdds(moreItems['twh'], 2) == true)")
              moreTW(:source="source" :mode="mode")
            template(v-if="(moreItems['oehm'] != null && checkOdds(moreItems['oehm'], 1, 'oehm') == true) || (moreItems['oehmh'] != null && checkOdds(moreItems['oehmh'], 1, 'oehmh') == true)")
              moreOEHM(:source="source" :mode="mode")
            template(v-if="(moreItems['oeaw'] != null && checkOdds(moreItems['oeaw'], 1, 'oeaw') == true) || (moreItems['oeawh'] != null && checkOdds(moreItems['oeawh'], 1, 'oeawh') == true)")
              moreOEAW(:source="source" :mode="mode")
            template(v-if="(moreItems['dnb'] != null && checkOdds(moreItems['dnb'], 0) == true) || (moreItems['dnbh'] != null && checkOdds(moreItems['dnbh'], 0) == true)")
              moreDNB(:source="source" :mode="mode")
            template(v-if="(moreItems['etg'] != null && checkOdds(moreItems['etg'], 0) == true) || (moreItems['etgh'] != null && checkOdds(moreItems['etgh'], 0) == true)")
              moreETG(:source="source" :mode="mode")
            template(v-if="(moreItems['ehtg'] != null && checkOdds(moreItems['ehtg'], 0) == true) || (moreItems['ehtgh'] != null && checkOdds(moreItems['ehtgh'], 0) == true)")
              moreEHTG(:source="source" :mode="mode")
            template(v-if="(moreItems['eatg'] != null && checkOdds(moreItems['eatg'], 0) == true) || (moreItems['eatgh'] != null && checkOdds(moreItems['eatgh'], 0) == true)")
              moreEATG(:source="source" :mode="mode")
          template(v-if="[0,1].includes(mode)")
            template(v-if="moreItems['htft'] != null && checkOdds(moreItems['htft'], 0) == true")
              moreHTFT(:source="source" :mode="mode")
            template(v-if="moreItems['cl'] != null && checkOdds(moreItems['cl'], 0) == true")
              moreCL(:source="source" :mode="mode")
            template(v-if="moreItems['bs'] != null && checkOdds(moreItems['bs'], 0) == true")
              moreBS(:source="source" :mode="mode")
            template(v-if="moreItems['hnb'] != null && checkOdds(moreItems['hnb'], 0) == true")
              moreHNB(:source="source" :mode="mode")
            template(v-if="moreItems['anb'] != null && checkOdds(moreItems['anb'], 0) == true")
              moreANB(:source="source" :mode="mode")
            template(v-if="moreItems['twtn'] != null && checkOdds(moreItems['twtn'], 0) == true")
              moreTWTN(:source="source" :mode="mode")
            template(v-if="moreItems['ouoe'] != null && checkOdds(moreItems['ouoe'], 0) == true")
              moreOUOEnew(:source="source" :mode="mode")
            template(v-if="moreItems['htftoe'] != null && checkOdds(moreItems['htftoe'], 0) == true")
              moreHTFTOE(:source="source" :mode="mode")
            template(v-if="moreItems['oxtou'] != null && checkOdds(moreItems['oxtou'], 0) == true")
              moreOXTOU(:source="source" :mode="mode")
            template(v-if="moreItems['dcou'] != null && checkOdds(moreItems['dcou'], 0) == true")
              moreDCOU(:source="source" :mode="mode")
            template(v-if="moreItems['wm'] != null && checkOdds(moreItems['wm'], 0) == true")
              moreWM(:source="source" :mode="mode")
            template(v-if="moreItems['cshtft'] != null")
              moreHTFTCS(:source="source" :mode="mode") 
            template(v-if="moreItems['etghtft'] != null")
              moreHTFTETG(:source="source" :mode="mode") 
          template(v-if="[3].includes(mode) && [1].includes(sportsType)")
            template(v-for="(sitem, skey) in child1Ids" v-if="isDataMMOEmptyModeMore(hdpou(sitem[0])) && mmoMode && menu3 != 'parlay'")
              moreHDPOUMMO1(:source="hdpou(sitem[0])" :childId="sitem[0]")
            template(v-for="(sitem, skey) in child1Ids" v-if="isDataEmptyModeMore(hdpou(sitem[0]))")
              moreOXTHDPOUOE(:source="hdpou(sitem[0])" :childId="sitem[0]")
          template(v-if="[3].includes(mode) && ![1].includes(sportsType)")
            template(v-for="(sitem, skey) in child1Ids" v-if="isDataEmptyModeMore(hdpou(sitem[0]))")
              moreMLHDPOUOE(:source="hdpou(sitem[0])" :childId="sitem[0]")
          template(v-if="[4].includes(mode) && [1].includes(sportsType)")
            template(v-for="(sitem, skey) in child2Ids" v-if="isDataMMOEmptyModeMore(hdpou(sitem[0])) && mmoMode && menu3 != 'parlay'")
              moreHDPOUMMO1(:source="hdpou(sitem[0])" :childId="sitem[0]")
            template(v-for="(sitem, skey) in child2Ids" v-if="isDataEmptyModeMore(hdpou(sitem[0]))")
              template(v-if="sitem[2] == 4")
                moreOUSP(:source="hdpou(sitem[0])" :childId="sitem[0]")
              template(v-else)
                moreOXTHDPOUOE(:source="hdpou(sitem[0])" :childId="sitem[0]")
          template(v-if="[0].includes(mode) && ![1, 2, 5, 6, 8, 9, 20].includes(sportsType)")
            template(v-for="(sitem, skey) in child2Ids")
              moreMLHDPOUOE(:source="hdpou(sitem[0])" :childId="sitem[0]" :sid="sportsType")
          template(v-if="[20].includes(sportsType)")
            template(v-for="(sitem, skey) in child2Ids" v-if="emode == sitem[2] && isDataEmptyEsportMore(hdpou(sitem[0]))")
              moreMLHDPOUOE(:source="hdpou(sitem[0])" :childId="sitem[0]" :sid="sportsType")
          template(v-if="[0].includes(mode) && [2, 5, 6, 8, 9].includes(sportsType)")
            template(v-for="(sitem, skey) in child2Ids")
              template(v-if="sitem[2] == 2")
                moreMLHDPOUOE(:source="hdpou(sitem[0])" :childId="sitem[0]" :sid="sportsType")
              template(v-if="sitem[2] == 3")
                moreHDPSL(:source="hdpou(sitem[0])" :childId="sitem[0]")
              template(v-if="sitem[2] == 4")
                moreOUSL(:source="hdpou(sitem[0])" :childId="sitem[0]")
              template(v-if="sitem[2] == 5")
                moreOE(:source="hdpou(sitem[0])" :childId="sitem[0]")
              template(v-if="sitem[2] == 7")
                moreOUOE(:source="hdpou(sitem[0])" :childId="sitem[0]")
              template(v-if="sitem[2] == 8")
                moreMLOE(:source="hdpou(sitem[0])" :childId="sitem[0]")
              template(v-if="sitem[2] == 9")
                moreOXTHDP(:source="hdpou(sitem[0])" :childId="sitem[0]")
        template(v-else)
          template(v-for="(sitem, skey) in child2Ids" v-if="emode == sitem[2]")
            template(v-if="[41, 42, 43, 44, 47].includes(sportsType) && isDataEmptyEsportMore(hdpou(sitem[0]))")
              template(v-if="isDataEmptyHDPSFVMore(hdpou(sitem[0]))")
                moreHDPSL(:source="hdpou(sitem[0])" :childId="sitem[0]")
              template(v-if="isDataEmptyOUSFVMore(hdpou(sitem[0]))")
                moreOUSL(:source="hdpou(sitem[0])" :childId="sitem[0]")
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";
import moreCS from "@/components/mobile/main/more/moreCS";
import moreHDP from "@/components/mobile/main/more/moreHDP";
import moreOXT from "@/components/mobile/main/more/moreOXT";
import moreHDPSL from "@/components/mobile/main/more/moreHDPSL";
import moreOU from "@/components/mobile/main/more/moreOU";
import moreOUSL from "@/components/mobile/main/more/moreOUSL";
import moreOE from "@/components/mobile/main/more/moreOE";
import moreDC from "@/components/mobile/main/more/moreDC";
import moreTG from "@/components/mobile/main/more/moreTG";
import moreHTFT from "@/components/mobile/main/more/moreHTFT";
import moreFGLG from "@/components/mobile/main/more/moreFGLG";
import moreML from "@/components/mobile/main/more/moreML";
import moreCL from "@/components/mobile/main/more/moreCL";
import moreBS from "@/components/mobile/main/more/moreBS";
import moreANB from "@/components/mobile/main/more/moreANB";
import moreDNB from "@/components/mobile/main/more/moreDNB";
import moreHNB from "@/components/mobile/main/more/moreHNB";
import moreTWTN from "@/components/mobile/main/more/moreTWTN";
import moreOXTHDPOUOE from "@/components/mobile/main/more/moreOXTHDPOUOE";
import moreMLHDPOUOE from "@/components/mobile/main/more/moreMLHDPOUOE";
import moreTW from "@/components/mobile/main/more/moreTW";
import moreOUOE from "@/components/mobile/main/more/moreOUOE";
import moreMLOE from "@/components/mobile/main/more/moreMLOE";
import moreOXTHDP from "@/components/mobile/main/more/moreOXTHDP";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import moreOUSP from "@/components/mobile/main/more/moreOUSP";
import moreHDPOUMMO from "@/components/mobile/main/more/moreHDPOUMMO";
import moreHDPOUMMO1 from "@/components/mobile/main/more/moreHDPOUMMO1";

import moreOEHM from "@/components/mobile/main/more/moreOEHM";
import moreOEAW from "@/components/mobile/main/more/moreOEAW";
import moreOUOEnew from "@/components/mobile/main/more/moreOUOEnew";
import moreHTFTOE from "@/components/mobile/main/more/moreHTFTOE";
import moreOXTOU from "@/components/mobile/main/more/moreOXTOU";
import moreDCOU from "@/components/mobile/main/more/moreDCOU";
import moreWM from "@/components/mobile/main/more/moreWM";
import moreETG from "@/components/mobile/main/more/moreETG";
import moreEHTG from "@/components/mobile/main/more/moreEHTG";
import moreEATG from "@/components/mobile/main/more/moreEATG";
import moreHTFTCS from "@/components/mobile/main/more/moreHTFTCS";
import moreHTFTETG from "@/components/mobile/main/more/moreHTFTETG";

export default {
  components: {
    moreCS,
    moreHDP,
    moreOXT,
    moreHDPSL,
    moreOU,
    moreOUSL,
    moreOE,
    moreDC,
    moreTG,
    moreHTFT,
    moreFGLG,
    moreML,
    moreCL,
    moreBS,
    moreANB,
    moreDNB,
    moreHNB,
    moreTWTN,
    moreOXTHDPOUOE,
    moreMLHDPOUOE,
    moreTW,
    moreOUOE,
    moreMLOE,
    moreOXTHDP,
    moreOUSP,
    moreHDPOUMMO,
    moreHDPOUMMO1,
    moreOEHM,
    moreOEAW,
    moreOUOEnew,
    moreHTFTOE,
    moreOXTOU,
    moreDCOU,
    moreWM,
    moreETG,
    moreEHTG,
    moreEATG,
    moreHTFTCS,
    moreHTFTETG
  },
  mixins: [mixinHDPOUOdds],
  props: {
    child1Ids: {
      type: Array
    },
    child2Ids: {
      type: Array
    }
  },
  data() {
    return {
      mode: 0,
      emode: 101,
      win: []
    };
  },
  computed: {
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    isDetailsTotal() {
      return this.moreItems.total > 0;
    },
    isDetailsFull() {
      return this.moreItems.full > 0;
    },
    isDetailsHalf() {
      return this.moreItems.half > 0;
    },
    isChild1() {
      return this.child1Ids ? this.child1Ids.length > 0 : false;
    },
    isChild2() {
      return this.child2Ids ? this.child2Ids.length > 0 : false;
    },
    esportTab() {
      var sportTab = {};

      if (this.child1Ids) {
        this.child2Ids.forEach((v, k) => {
          if (config.esportsTab.hasOwnProperty(v[2]) && this.isDataEmptyEsportMore(this.hdpou(v[0]))) {
            sportTab[v[2]] = config.esportsTab[v[2]];
          }
        });
      }
      return sportTab;
    },
    sport4dTab() {
      var sportTab = {};
      if (this.child1Ids) {
        this.child2Ids.forEach((v, k) => {
          if (config.sports4dTab.hasOwnProperty(v[2]) && this.isDataEmptyEsportMore(this.hdpou(v[0]))) {
            sportTab[v[2]] = config.sports4dTab[v[2]];
          }
        });
      }
      return sportTab;
    },
    sportSFVTab() {
      var sportTab = {};
      if (this.child1Ids) {
        this.child2Ids.forEach((v, k) => {
          if (config.sportsSFVTab.hasOwnProperty(v[2]) && this.isDataEmptyEsportMore(this.hdpou(v[0]))) {
            sportTab[v[2]] = config.sportsSFVTab[v[2]];
          }
        });
      }
      return sportTab;
    },
    checkTabMode3() {
      var flag = false;
      this.child1Ids.forEach((v, k) => {
        if (this.isDataEmptyModeMore(this.hdpou(v[0]))) {
          flag = true;
        }
      });
      return flag;
    },
    checkTabMode4() {
      var flag = false;
      this.child2Ids.forEach((v, k) => {
        if (this.isDataEmptyModeMore(this.hdpou(v[0]))) {
          flag = true;
        }
      });
      return flag;
    }
  },
  watch: {
    esportTab(newVal, oldVal) {
      try {
        var a = Object.keys(newVal);
        var b = Object.keys(oldVal);
        if (a.length != b.length) {
          if (a.length > 0) {
            this.goToTab(a[0]);
          }
        }
      } catch {}
    },
    sport4dTab(newVal, oldVal) {
      try {
        var a = Object.keys(newVal);
        var b = Object.keys(oldVal);
        if (a.length != b.length) {
          if (a.length > 0) {
            this.goToTab(a[0]);
          }
        }
      } catch {}
    },
    sportSFVTab(newVal, oldVal) {
      try {
        var a = Object.keys(newVal);
        var b = Object.keys(oldVal);
        if (a.length != b.length) {
          if (a.length > 0) {
            this.goToTab(a[0]);
          }
        }
      } catch {}
    }
  },
  mounted() {
    // var scroll1 = document.querySelector("#pills-tab .nav-item a.active");
    // scroll1.scrollIntoView({
    //   inline: "center"
    // });
  },
  methods: {
    toggleAll() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
        setTimeout(() => {
          // $(".collapse").collapse("show");
          $(".collapse").addClass("show");
          $(".collapse-more").removeClass("collapsed").attr("aria-expanded", "true");
        }, 100);
      } else {
        elem.removeClass("open-all");
        elem.addClass("close-all");
        setTimeout(() => {
          // $(".collapse").collapse("hide");
          $(".collapse").removeClass("show");
          $(".collapse-more").addClass("collapsed").attr("aria-expanded", "false");
        }, 100);
      }
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      // var elem = $(".btn-collapse");
      // if (elem.hasClass("close-all")) {
      //   elem.removeClass("close-all");
      //   elem.addClass("open-all");
      // }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    toggleFavorite() {
      if (this.menu0 != "favorite") {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "favorite";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      } else {
        this.resetSelectLeague();
        this.clearSearch();
        var mi5 = {};
        mi5["menuX"] = false;
        mi5["menuY"] = "0";
        mi5["menu0"] = "all";
        mi5["menu1"] = "today";
        mi5["menu3"] = "hdpou";
        this.$store.dispatch("layout/setMenuItems", mi5);
        EventBus.$emit("INVALIDATE", mi5);
      }
      this.$router.push("/prematch").catch(err => {});
    },
    isDataEmptyModeMore(details) {
      var hdp = details["hdp"] != null && details["hdp"][0] != null;
      var hdph = details["hdph"] != null && details["hdph"][0] != null;
      var ou = details["ou"] != null && details["ou"][0] != null;
      var ouh = details["ouh"] != null && details["ouh"][0] != null;
      var oxt = details["oxt"] != null && details["oxt"][0] != null;
      var oxth = details["oxth"] != null && details["oxth"][0] != null;
      var oe = details["oe"] != null && details["oe"][0] != null;
      var oeh = details["oeh"] != null && details["oeh"][0] != null;
      var ml = details["ml"] != null && details["ml"][0] != null;
      var mlh = details["mlh"] != null && details["mlh"][0] != null;
      return hdp || ou || oe || oxt || hdph || ouh || oxth || oeh || ml || mlh;
    },
    isDataEmptyEsportMore(details) {
      var hdp = details["hdp"] != null && details["hdp"][0] != null;
      var ou = details["ou"] != null && details["ou"][0] != null;
      var ml = details["ml"] != null && details["ml"][0] != null;
      var oe = details["oe"] != null && details["oe"][0] != null;
      return hdp || ou || oe || ml;
    },
    isDataEmptyHDPSFVMore(details) {
      var hdp = details["hdp"] != null && details["hdp"][0] != null;
      return hdp;
    },
    isDataEmptyOUSFVMore(details) {
      var ou = details["ou"] != null && details["ou"][0] != null;
      return ou;
    },
    isDataMMOEmptyModeMore(details) {
      var hdp = details["mmo"]["hdp"] != null && details["mmo"]["hdp"][0] != null;
      var hdph = details["mmo"]["hdph"] != null && details["mmo"]["hdph"][0] != null;
      var ou = details["mmo"]["ou"] != null && details["mmo"]["ou"][0] != null;
      var ouh = details["mmo"]["ouh"] != null && details["mmo"]["ouh"][0] != null;
      return hdp || ou || hdph || ouh;
    },
    show4dStats(e) {
      alert(e);
    },
    handleDefaultTab() {
      switch (this.mode) {
        case 0:
          if (this.details.total <= 0) {
            if (this.child1Ids.length > 0) {
              this.goToTab(3);
            } else {
              if (this.child2Ids.length > 0) {
                this.goToTab(0);
              }
            }
          }
          break;
        case 1:
          if (this.details.full <= 0) {
            this.goToTab(0);
          }
          break;
        case 2:
          if (this.details.half <= 0) {
            this.goToTab(0);
          }
          break;
        case 3:
          if (this.child1Ids.length <= 0) {
            this.goToTab(0);
          }
          break;
        case 4:
          if (this.child2Ids.length <= 0) {
            this.goToTab(0);
          }
          break;
      }

      if ([20, 40, 41, 42, 43, 44, 47].includes(this.sportsType)) {
        var done = false;
        if (this.child2Ids) {
          this.child2Ids.forEach((v, k) => {
            if (!done) {
              this.emode = v[2];
              done = true;
            }
            return false;
          });
        }
        this.goToTab(this.emode);
      }
    },
    setDefaultTab() {
      this.handleDefaultTab();
    },
    league() {
      return this.$store.getters.data.league;
    },
    head() {
      return this.$store.getters.data.head;
    },
    match() {
      return this.$store.getters.data.match;
    },
    leagueName(data) {
      var result = data["league"].split(" - ");
      if (result.length >= 2) {
        return result[result.length - 1].toLowerCase().trim();
      }
      return this.details["league"].toLowerCase().trim();
    },
    odds() {
      if (this.$store.getters.data.hasOwnProperty("odds")) {
        if (this.$store.getters.data.odds[this.layoutIndex] != null) {
          return this.$store.getters.data.odds[this.layoutIndex];
        } else {
          return {};
        }
      }
      return {};
    },
    mmo() {
      if (this.$store.getters.data.hasOwnProperty("mmo")) {
        if (this.$store.getters.data.mmo[this.layoutIndex] != null) {
          return this.$store.getters.data.mmo[this.layoutIndex];
        } else {
          return {};
        }
      }
      return {};
    },
    hdpouMMO(e) {
      var odds = this.mmo();
      var r = {};
      r["tn"] = 0;
      r["team"] = null;
      r["oxtn"] = 0;
      r["more"] = 0;

      if (odds != null) {
        if (odds.hasOwnProperty("hdp")) {
          if (odds["hdp"][e] != null) {
            r["hdp"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDP";
            });
            r["hdph"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDPH";
            });
            if (r["hdp"] ? r["hdp"].length : 0 > r["tn"]) {
              r["tn"] = r["hdp"].length;
              if (r["hdp"][0][8] != null && r["hdp"][0][8] != "0") {
                r["team"] = r["hdp"][0][7];
              } else {
                r["team"] = 2;
              }
            } else {
              r["hdp"] = null;
            }
            if (r["hdph"] ? r["hdph"].length : 0 > r["tn"]) {
              if (r["tn"] < r["hdph"].length) {
                r["tn"] = r["hdph"].length;
              }
              if (r["team"] == null) {
                if (r["hdph"][0][8] != null && r["hdph"][0][8] != "0") {
                  r["team"] = r["hdph"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["hdph"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ou")) {
          if (odds["ou"][e]) {
            r["ou"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OU";
            });
            r["ouh"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OUH";
            });
            if (r["ou"] ? r["ou"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ou"].length) {
                r["tn"] = r["ou"].length;
              }
              if (r["team"] == null) {
                if (r["ou"][0][8] != null && r["ou"][0][8] != "0") {
                  r["team"] = r["ou"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ou"] = null;
            }
            if (r["ouh"] ? r["ouh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ouh"].length) {
                r["tn"] = r["ouh"].length;
              }
              if (r["team"] == null) {
                if (r["ouh"][0][8] != null && r["ouh"][0][8] != "0") {
                  r["team"] = r["ouh"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ouh"] = null;
            }
          }
        }
      }
      return r;
    },
    hdpou(e) {
      var odds = this.odds();
      var r = {};
      r["tn"] = 0;
      r["team"] = null;
      r["oxtn"] = 0;
      r["more"] = 0;

      r["mmo"] = {};

      if (odds != null) {
        if (odds.hasOwnProperty("hdp")) {
          if (odds["hdp"][e] != null) {
            r["hdp"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDP";
            });
            r["hdph"] = odds["hdp"][e].filter((v, i, r) => {
              return v[4] == "HDPH";
            });
            if (r["hdp"] ? r["hdp"].length : 0 > r["tn"]) {
              r["tn"] = r["hdp"].length;
              if (r["hdp"][0][8] != null && r["hdp"][0][8] != "0") {
                r["team"] = r["hdp"][0][7];
              } else {
                r["team"] = 2;
              }
            } else {
              r["hdp"] = null;
            }
            if (r["hdph"] ? r["hdph"].length : 0 > r["tn"]) {
              if (r["tn"] < r["hdph"].length) {
                r["tn"] = r["hdph"].length;
              }
              if (r["team"] == null) {
                if (r["hdph"][0][8] != null && r["hdph"][0][8] != "0") {
                  r["team"] = r["hdph"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["hdph"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ou")) {
          if (odds["ou"][e]) {
            r["ou"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OU";
            });
            r["ouh"] = odds["ou"][e].filter((v, i, r) => {
              return v[4] == "OUH";
            });
            if (r["ou"] ? r["ou"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ou"].length) {
                r["tn"] = r["ou"].length;
              }
              if (r["team"] == null) {
                if (r["ou"][0][8] != null && r["ou"][0][8] != "0") {
                  r["team"] = r["ou"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ou"] = null;
            }
            if (r["ouh"] ? r["ouh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ouh"].length) {
                r["tn"] = r["ouh"].length;
              }
              if (r["team"] == null) {
                if (r["ouh"][0][8] != null && r["ouh"][0][8] != "0") {
                  r["team"] = r["ouh"][0][7];
                } else {
                  r["team"] = 2;
                }
              }
            } else {
              r["ouh"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("oxt")) {
          if (odds["oxt"][e]) {
            r["oxt"] = odds["oxt"][e].filter((v, i, r) => {
              return v[4] == "1X2";
            });
            r["oxth"] = odds["oxt"][e].filter((v, i, r) => {
              return v[4] == "1X2H";
            });
            if (r["oxt"] ? r["oxt"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oxt"].length) {
                r["tn"] = r["oxt"].length;
              }
              r["oxtn"] = 1;
            } else {
              r["oxt"] = null;
            }
            if (r["oxth"] ? r["oxth"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oxth"].length) {
                r["tn"] = r["oxth"].length;
              }
              r["oxtn"] = 1;
            } else {
              r["oxth"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("oe")) {
          if (odds["oe"][e]) {
            r["oe"] = odds["oe"][e].filter((v, i, r) => {
              return v[4] == "OE";
            });
            r["oeh"] = odds["oe"][e].filter((v, i, r) => {
              return v[4] == "OEH";
            });
            if (r["oe"] ? r["oe"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oe"].length) {
                r["tn"] = r["oe"].length;
              }
              r["oen"] = 1;
            } else {
              r["oe"] = null;
            }
            if (r["oeh"] ? r["oeh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["oeh"].length) {
                r["tn"] = r["oeh"].length;
              }
              r["oehn"] = 1;
            } else {
              r["oeh"] = null;
            }
          }
        }

        if (odds.hasOwnProperty("ml")) {
          if (odds["ml"][e]) {
            r["ml"] = odds["ml"][e].filter((v, i, r) => {
              return v[4] == "ML";
            });
            r["mlh"] = odds["ml"][e].filter((v, i, r) => {
              return v[4] == "MLH";
            });
            if (r["ml"] ? r["ml"].length : 0 > r["tn"]) {
              if (r["tn"] < r["ml"].length) {
                r["tn"] = r["ml"].length;
              }
              r["mln"] = 1;
            } else {
              r["ml"] = null;
            }
            if (r["mlh"] ? r["mlh"].length : 0 > r["tn"]) {
              if (r["tn"] < r["mlh"].length) {
                r["tn"] = r["mlh"].length;
              }
              r["mlhn"] = 1;
            } else {
              r["mlh"] = null;
            }
          }
        }

        var head = this.head();
        var match = this.match();
        if (head[e] == undefined) {
          r["more"] = 0;
        } else {
          r["head"] = head[e][0];
          r["match"] = match[e];
          if (r["head"] != null) {
            r["more"] = head[e][0][7];
          }
          if (r["match"] != null) {
            r["league"] = this.league()[r["match"][1]][4];
          }
        }
      }

      // console.log("mmoMode: ", this.mmoMode)
      if (this.mmoMode) {
        r["mmo"] = this.hdpouMMO(e);
      }

      this.result = null;
      this.result = r;
      return r;
    },
    goToTab(mode) {
      if ([20, 40, 41, 42, 43, 44, 47].includes(this.sportsType)) {
        this.emode = mode;
        return;
      }
      this.mode = mode;
    },
    checkOdds(e, t, z) {
      var result = false;


      if (e == undefined || t == undefined) {
        return result;
      }
      // console.log(e, t, z);

      switch (t) {
        case 1:
          e.forEach(value => {
            if (value[5] != null && value[5] != "" && value[7] != null && value[7] != "") {
              // result = this.menu3 != "parlay" ? true : ["ML", "MLH", "OE", "OEH"].includes(value[4]) ? value[13] == 1 : value[8] == 1;
              result = this.menu3 != "parlay" ? true : value[8] == 1;
            }
          });
          break;
        case 2:
          e.forEach(value => {
            if (value[5] != null && value[5] != "" && value[6] != null && value[6] != "" && value[7] != null && value[7] != "") {
              result = this.menu3 != "parlay" ? true : value[8] == 1;
            }
          });
          break;
        default:
          e.forEach(value => {
            if (value[5] != null && value[5] != "") {
              // result = this.menu3 != "parlay" ? true : ["HDP", "HDPH", "OU", ,"OUH", "OXT", "OXTH"].includes(value[4]) ? value[13] == 1 : value[8] == 1;
              result = this.menu3 != "parlay" ? true : value[8] == 1;
            }
          });
          break;
      }

      return result;
    },
    popupTV(e) {
      var canPlay = false;
      if (this.win.length < 4) {
        canPlay = true;
      } else {
        for (var n = 0; n < this.win.length; n++) {
          if (this.win[n].closed == true || this.win[n].name == e.match_id) {
            this.win.splice(n, 1);
            canPlay = true;
          }
        }
      }
      if (canPlay) {
        var w = 640; //screen.availWidth / 2;
        var h = 360; //screen.availHeight / 2;
        if (e.channelId) {
          var url = "/livetv?channel=" + e.channelId + "&match=" + e.matchId + "&sports=" + e.sportsId;
          var opts = "height=" + h + ",width=" + w + ",status=no,toolbar=no,menubar=no,location=no,resizable=yes";
          var w = window.open(url, e.matchId, opts);
          var canAdd = true;
          for (var n = 0; n < this.win.length; n++) {
            if (this.win[n] == w) {
              canAdd = false;
              break;
            }
          }
          if (canAdd) {
            this.win.push(w);
            // console.log(this.win);
          }
        }
      } else {
        alert("You have exceeded your video streaming limit. Please close one if you wish to open another new session.");
      }
    },
  }
}
</script>